import clsx from "clsx";
import React, { useId } from "react";
import { ICON_SIZES } from "../../helpers/constants";
import { MdCheck, MdOutlinePriorityHigh } from "react-icons/md";
import { Tooltip } from "react-tooltip";

interface IFieldLabel {
  htmlFor?: string;
  required?: boolean;
  text: string;
  valid?: boolean;
  onClick?: () => void;
  className?: string;
}

const FieldLabel: React.FC<IFieldLabel> = ({
  htmlFor,
  required = false,
  text,
  valid = false,
  onClick = () => undefined,
  className = "",
}) => {
  const tooltipId = useId();

  return (
    <label
      htmlFor={htmlFor}
      className={clsx([
        "text-sm",
        "md:text-sm",
        "dark:text-gray-100",
        "font-medium",
        "inline-flex",
        className,
      ])}
      onClick={onClick}
    >
      <div
        data-tooltip-id={tooltipId}
        data-tooltip-content={required ? "Este campo es requerido" : ""}
        data-tooltip-position-strategy="fixed"
        data-tooltip-offset={0}
        className="truncate"
      >
        {text}
      </div>
      {required && (
        <>
          <span
            className={clsx([
              "ml-1",
              "cursor-help",
              {
                "text-lime-400": valid,
                "text-red-500 dark:text-rose-400/80": !valid,
              },
            ])}
            data-tooltip-id={tooltipId}
            data-tooltip-content={required ? "Este campo es requerido" : ""}
            data-tooltip-position-strategy="fixed"
            data-tooltip-offset={0}
          >
            {valid ? (
              <>
                <MdCheck size={ICON_SIZES.XS} />
                <Tooltip id={tooltipId} style={{ zIndex: 99 }} />
              </>
            ) : (
              <>
                <MdOutlinePriorityHigh size={ICON_SIZES.XS} />
                <Tooltip id={tooltipId} style={{ zIndex: 99 }} />
              </>
            )}
            <Tooltip id={tooltipId} style={{ zIndex: 99 }} />
          </span>
        </>
      )}
    </label>
  );
};

export default React.memo(FieldLabel);
